<router-outlet (activate)='onActivate($event)' (deactivate)='onDeactivate($event)'></router-outlet>


